import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { App } from "./App";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<ThemeProvider attribute="class" defaultTheme="light" enableSystem data-id="element-50" data-mp="218mohd78tx4r">
      <App data-id="element-51" data-mp="26abx6m6ztypo" />
    </ThemeProvider>);
}